import Tone from 'tone';
import Formants from './Formants.js';
import {setEffectParameterValues} from 'actions/index.js';
import Formant from './Formant.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

const NUMBER_FORMANTS = 6;
export default superclass => class extends superclass  {

    get formants() {
        return this.formantsManager.formants;
    }

    setupFormants(reload=false) {
        this.formantsManager = new Formants(this);
        /*
        if (!reload) {
            // create the formants

            this.formants = [];
            for (let i=0; i < NUMBER_FORMANTS; i++) {
                this.formants.push(new Formant(this, i));
            }
        } else {
            // we are reloading (i.e. the poly changed and we spawned a new
            // synth). So we need to hook up all the parameters to their
            // audio params once again
            this.formants.forEach(s => s.setup(true));
        }
        */
    }

    initializeFormants(voices=this.voices) {
        /*
        for (let voice of voices) {
            if (voice.formantsFilter !== undefined) {
                // we've already made it
                continue;
            }
            
            voice.envelope.disconnect(voice.output);
            voice.formantFilters = [];
            voice.formantGains = [];
       }
       */
    }

    copyFormants(voice, initialize=false) {
        // we have a new voice and we want to make sure the formants are on this one too
        /*
        if (initialize || this.formants.some(formant => formant.enabledParameter.get())) {
            this.initializeFormants([voice]);
        }
        for (let formant of this.formants) {
            if (!formant.enabledParameter.get()) {
                continue;
            }

            // its enabled so we need to initialize and connect
            formant.connectToSynth([voice]);
            formant.refreshParameters();
        }
        */
    }

    voiceHasFormant(voice) {
        return voice.formantFilters !== undefined;
    }

    destroyFormants(synth=this, reconnect=true, disconnectParameters=true) {
    }

    getFormantsJson(isPreset) {
        return this.formants.map(formant => formant.getJson(isPreset));
    }

    loadFormantsJson(json, ignoreId) {
        this.formants.forEach(x => x.ripMods());
        if (Tone.Master.context.isOffline) {
            let bulk = {};
                for (let i in json) {
                    bulk = {... bulk, ...this.formants[i].fromJson(json[i], ignoreId)};
                }
            return bulk;
        } else {
            let offset = this.instrument.oscillatorNodes.indexOf(this);
            let bulk = {};
            for (let i in json) {
                bulk = {... bulk, ...this.formants[i].fromJson(json[i], ignoreId)};
            }
            return bulk;
        }
    }
}
